<!-- src/App.vue -->
<template>
    
      <WPPrintView :gatepasses_data="gatepass"/>
     
  </template>
  
  <script>
  import WPPrintView from '@/components/WPPrintView.vue';
//   import axios from 'axios';
import axios from "@/plugins/axios";
  
  export default {
    name: 'GatePassView',
    components: {
      WPPrintView
    },  data() {
        return {
             gatepass:[]// { "name": '', "firmname": '',"contact": '', "address": '',"purpose": '','designation':'','schedule_date':'' } 
            
        }
    },
    mounted() {
            if (this.$route.query.q) {
                this.getBasics(this.$route.query.q);
            }
        }, 
    methods: {
            getBasics(passid) {
            var self = this;
            axios.post('getWorkPermitForPrint',{id:passid}).then(function (response) {
                self.gatepass = response.data.workpermitdetails; 
                window.scrollTo(0, 0);
            });
        },
        }
  };
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');
  
    
  </style>
  